export default __webpack_public_path__ + "github.60a5f230.png";